import { useMutation } from "react-query";
import { fetchBrandLogo, fetchProducts } from ".";

export const useBrandLogo = () => useMutation(fetchBrandLogo);

export const useProducts = () => useMutation(fetchProducts);
